module.exports = __webpack_public_path__ + "static/media/DroneBlackMap.1a41a1fa.svg";